import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import HubTabsBar from '../../../components/HubTabsBar';
import { PM_TABS } from '../../../hubs/pmTabs';

import AdminPmCompanies from '../PmCompanies';
import AdminPmProperties from '../PmProperties';
import AdminPmPropertyRequests from '../PmPropertyRequests';
import AdminPmAccounts from '../PmAccounts';
import AdminPmServiceRequests from '../PmServiceRequests';
import AdminPoReports from '../PoReports';
import AdminPmAssets from '../PmAssets';
import AdminPmCrm from '../PmCrm';

const TAB_COMPONENT = {
  'companies':         AdminPmCompanies,
  'properties':        AdminPmProperties,
  'property-requests': AdminPmPropertyRequests,
  'accounts':          AdminPmAccounts,
  'service-requests':  AdminPmServiceRequests,
  'po-reports':        AdminPoReports,
  'assets':            AdminPmAssets,
  'crm':               AdminPmCrm,
};

const PmHub = () => {
  const { user } = useAuth();
  const role = user?.role;
  const { tabKey } = useParams();

  const visibleTabs = PM_TABS.filter((t) => t.allow.has(role));
  if (visibleTabs.length === 0) {
    return (
      <div data-testid="pm-hub-no-access" className="bg-[#141414] border border-[#262626] rounded-md p-8 text-center text-[#A3A3A3]">
        You don&apos;t have access to any Property Management tools.
      </div>
    );
  }
  if (!tabKey) return <Navigate to={visibleTabs[0].path} replace />;
  const active = visibleTabs.find((t) => t.key === tabKey);
  if (!active) return <Navigate to={visibleTabs[0].path} replace />;

  const Component = TAB_COMPONENT[active.key];
  return (
    <div data-testid="pm-hub" className="space-y-4">
      <HubTabsBar tabs={PM_TABS} userRole={role} testIdPrefix="pm" />
      <div data-testid={`pm-hub-content-${active.key}`}>
        {Component ? <Component /> : <div className="text-[#A3A3A3]">Coming soon.</div>}
      </div>
    </div>
  );
};

export default PmHub;
